import React, { FC } from 'react';
import { Typography, TypographyProps } from '@material-ui/core';
import { CampaignStatuses } from 'modules/crm/constants/campaigns';
import { CampaignStatus as CampaignStatusType } from 'common/constants/campaign';

const getColor = (status: CampaignStatusType) => {
  switch (status) {
    case CampaignStatusType.Active:
      return '#66cd00';
    case CampaignStatusType.Inactive:
      return '#32323266';
    case CampaignStatusType.Canceled:
      return '#ff2634';
    case CampaignStatusType.Completed:
      return '#2eabff';
    default:
      return '#323232';
  }
};

interface ICampaignStatus extends TypographyProps {
  status: CampaignStatusType;
}

const CampaignStatus: FC<ICampaignStatus> = ({ status, ...other }) => {
  const color = getColor(status);

  return (
    <Typography {...other} style={{ color }}>
      {CampaignStatuses.translate(status)}
    </Typography>
  );
};

export default CampaignStatus;
